import { combineReducers } from "redux";
import UserDataSlice from "./UserDataSlice";

export default combineReducers({
  /**Add more reducers here*/
  loginInfo: UserDataSlice,
});
